import React, { useState, useEffect } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import siteNavigation from "./nav-config";
import useAuth from "./auth/useAuth";
import GoogleLoginButton from "./auth/googleLoginButton";

const Sidebar = () => {
    const [isLoginFormVisible, setLoginFormVisible] = useState(false);
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [isSidebarVisible, setSidebarVisible] = useState(window.innerWidth > 768);

    const { isAuthenticated, login, logout, loading } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();;

    const { googleLogin } = useAuth();
    // console.log('googleLogin imp', googleLogin);

    const isActive = (item) => {
        const currentPath = location.pathname + location.hash;
        return currentPath === item.href;
    };

    useEffect(() => {
        const updateSidebarVisibility = () => {
            setSidebarVisible(window.innerWidth > 768);
        };

        updateSidebarVisibility();
        window.addEventListener("resize", updateSidebarVisibility);

        return () => window.removeEventListener("resize", updateSidebarVisibility);
    }, []); 

    const toggleSidebar = () => setSidebarVisible(!isSidebarVisible);

    const closeSidebar = () => {
        if (window.innerWidth <= 768) {
            setSidebarVisible(false);
        }
    };

    const toggleLogin = () => setLoginFormVisible(!isLoginFormVisible);

    const submitLogin = async () => {
        if (!email.trim() || !password.trim()) {
            setErrorMessage("Please enter both email and password.");
            return;
        }

        setErrorMessage(""); 

        try {
            const response = await fetch(`/api/auth/login`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ email: email.trim(), password: password.trim() }),
            });

            if (!response.ok) {
                throw new Error("Login failed");
            }

            const { token, user } = await response.json();
            login(token, user.displayName);
            setLoginFormVisible(false);
            setEmail("");
            setPassword("");
            navigate("/profile");
        } catch (error) {
            setErrorMessage("Login failed. Please try again.");
            console.error("Login error:", error);
        }
    };

    const handleGoogleLoginSuccess = async (credentialResponse) => {
        try {
            // Log the credential response
            console.log("Credential response received from Google login:", credentialResponse);
    
            // Validate the credential response
            if (!credentialResponse || !credentialResponse.credential) {
                throw new Error("Invalid credential response from Google login.");
            }
    
            const credentialToken = credentialResponse.credential;
    
            // Call googleLogin and log the response
            const response = await googleLogin(credentialToken);
            console.log("Google Login Response:", response); // This will now log the actual response
    
            // Validate the response structure
            if (!response || !response.tokens || !response.tokens.jwtToken || !response.tokens.googleToken) {
                // console.error("Invalid response structure:", response);
                throw new Error("Invalid response from googleLogin.");
            }
    
            // Extract data from the response
            const { googleToken, jwtToken } = response.tokens;
    
            // Login and navigate
            login(jwtToken, credentialResponse.displayName); // Update state with the new JWT token
            setLoginFormVisible(false);
            navigate("/profile");
        } catch (error) {
            // Log the error and update error message state
            setErrorMessage("Google login failed. Please try again.");
            // console.error("Google login error:", error);
        }
    };
    

    const sidebarStyle = {
        display: isSidebarVisible ? "block" : "none",
        position: "fixed",
        top: 0,
        left: 0,
        height: "100vh",
        overflowY: "auto",
        zIndex: 1000,
    };

    if (loading) {
        return <div>Loading...</div>;
    }

    return (
        <>
            <div className="sidebar-toggle" onClick={toggleSidebar}>☰ Menu</div>
            <div className="sidebar" style={sidebarStyle}>
                <div className="logo-container">
                    <Link to={siteNavigation.logo.href} onClick={closeSidebar}>
                        <img src={siteNavigation.logo.src} alt={siteNavigation.logo.alt} className="logo" />
                    </Link>
                </div>
                <hr className="custom-line" />

                {siteNavigation.menuItems
                    .filter((item) => !item.requiresLogin || isAuthenticated)
                    .map((item, index) => (
                <Link
                    key={index}
                    to={item.href}
                    className={isActive(item) ? "active" : ""}
                    onClick={closeSidebar}
                >
                    <span className="menu-item">
                        {item.icon && <span className="menu-icon">{item.icon}</span>}
                        <span className="menu-title">{item.title}</span>
                    </span>
                </Link>

                    ))}

              
                <hr className="custom-line" />

                {!isAuthenticated ? (
                    <>
                        <div id="login-form-container">
                        <div style={{ width: "160px", margin: "0 auto" }}>
                                <GoogleLoginButton handleSuccess={handleGoogleLoginSuccess} />
                                </div>
                                <br></br>
                        <button className="login-button" onClick={toggleLogin}>
                            {isLoginFormVisible ? "Close" : "Email Login"}
                        </button>
                        </div>
                        <br></br>
                        <br />
                        {isLoginFormVisible && (
                            <div id="login-form-container">
                                <input
                                    type="text"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    placeholder="Enter Email"
                                    required
                                />
                                <br />
                                <input
                                    type="text"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    placeholder="Enter Password"
                                    required
                                />
                                <br></br>
                                <br />
                                {errorMessage && <div className="error-message">{errorMessage}</div>}
                                <button
                                    className="login-button"
                                    type="button"
                                    onClick={submitLogin}
                                >
                                    Submit
                                </button>
                                <br></br>
                                <br />
                            </div>
                        )}
                    </>
                ) : (
                    <>
                        <div id="login-form-container">
                        <button className="login-button" type="button" onClick={logout}>
                            Logout
                        </button>
                        </div>
                        <br></br>
                        <br></br>
                        <br></br>
                    </>
                )}
            </div>
        </>
    );
};

export default Sidebar;





